import { Ring } from '../../components/bits';
import { useStore } from '../../state/store';
import { MONTH, MONTH_TOTAL, RHYTHM_BY_SERVICE } from '../../data/mock';
import { occupancy } from '../../lib/scheduling';
import { addDays } from '../../lib/time';

export function MonthView() {
  const s = useStore();
  const snap = s.snapshot;
  const max = Math.max(...MONTH.map(([a, b, c]) => a + b + c));
  const pct = ((MONTH_TOTAL.done + MONTH_TOTAL.scheduled) / MONTH_TOTAL.projected) * 100;
  return (
    <>
      <div className="row wrap" style={{ alignItems: 'stretch', gap: 16 }}>
        <section className="w" aria-label="Trabajos por día" style={{ flex: '999 1 620px' }}>
          <div className="wh"><div><h2>Octubre · trabajos por día</h2><div className="muted" style={{ fontSize: 13 }}>{MONTH_TOTAL.done + MONTH_TOTAL.scheduled} programados · ~{MONTH_TOTAL.projected} proyectados</div></div>
            <div className="row muted" style={{ fontSize: 12 }}>
              <span className="row" style={{ gap: 5 }}><i style={{ width: 12, height: 12, background: '#3A3A3D', borderRadius: 3 }} />Hechos</span>
              <span className="row" style={{ gap: 5 }}><i style={{ width: 12, height: 12, background: '#FAAF3B', borderRadius: 3 }} />Programados</span>
              <span className="row" style={{ gap: 5 }}><i style={{ width: 12, height: 12, border: '1.5px dashed #B07A20', borderRadius: 3 }} />Proyectados</span>
            </div></div>
          <div role="img" aria-label="Barras de trabajos por día de octubre" style={{ display: 'grid', gridTemplateColumns: 'repeat(31, minmax(0, 1fr))', gap: 4, alignItems: 'end', height: 210, borderBottom: '1px solid #E2E2DF' }}>
            {MONTH.map(([d, sc, pr], i) => {
              const isToday = i + 1 === 29;
              const k = 180 / max;
              return (
                <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: 4, justifyContent: 'flex-end', borderRadius: 4, outline: isToday ? '2px solid #FAAF3B' : undefined, outlineOffset: 3 }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    {pr > 0 && <div style={{ height: pr * k, border: '1.5px dashed #B07A20', borderRadius: 2 }} />}
                    {sc > 0 && <div style={{ height: sc * k, background: '#FAAF3B', borderRadius: 2 }} />}
                    {d > 0 && <div style={{ height: d * k, background: '#3A3A3D', borderRadius: 2 }} />}
                  </div>
                  <span style={{ fontSize: 10.5, textAlign: 'center', color: isToday ? '#1F1F21' : '#5E5F63', fontWeight: isToday ? 800 : 500 }}>{i + 1}</span>
                </div>
              );
            })}
          </div>
        </section>
        <section className="w" style={{ flex: '1 1 300px' }}>
          <h2 style={{ margin: 0, fontSize: 16 }}>Proyección de octubre</h2>
          <div className="row"><Ring pct={pct} color="#1F1F21" size={78} thickness={9} fontSize={16} />
            <div><span className="big">{MONTH_TOTAL.done + MONTH_TOTAL.scheduled}</span><div className="muted" style={{ fontSize: 12 }}>de ~{MONTH_TOTAL.projected} trabajos</div></div></div>
          <span className="muted" style={{ fontSize: 13 }}>{MONTH_TOTAL.done} hechos · {MONTH_TOTAL.scheduled} programados · {MONTH_TOTAL.projected - MONTH_TOTAL.done - MONTH_TOTAL.scheduled} por llenar</span>
          <div style={{ borderTop: '1px solid #F0EFEB', paddingTop: 10, display: 'flex', flexDirection: 'column', gap: 8 }}>
            <b style={{ fontSize: 13 }}>Ocupación de la próxima semana</b>
            {snap.teams.map(t => {
              const avg = Array.from({ length: 7 }, (_, i) => occupancy(snap, t.id, addDays(snap.today, i + 1))).reduce((a, b) => a + b, 0) / 7;
              return (
                <div key={t.id} className="row">
                  <span style={{ width: 10, height: 10, borderRadius: 3, background: t.color }} /><span style={{ flex: '0 0 70px' }}>{t.name}</span>
                  <div className="mini" style={{ flex: 1, height: 10 }}><i style={{ left: 0, width: `${avg * 100}%`, background: avg >= 0.9 ? '#E5484D' : t.color }} /></div>
                  <b style={{ width: 38, textAlign: 'right' }}>{Math.round(avg * 100)}%</b>
                </div>
              );
            })}
          </div>
        </section>
      </div>
      <section className="w" aria-label="Ritmo por tipo de servicio">
        <div className="wh"><h2>¿Cuánto tardan de verdad? · por tipo de servicio</h2><span className="muted" style={{ fontSize: 12 }}>real según registros de inicio y fin</span></div>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: 560 }}>
            <thead><tr>{['Servicio', 'Estimado', 'Real promedio', 'Diferencia'].map(h => <th key={h} style={{ textAlign: 'left', padding: '8px 10px', fontSize: 11, color: '#8A8B8E', textTransform: 'uppercase', letterSpacing: '.05em' }}>{h}</th>)}</tr></thead>
            <tbody>
              {RHYTHM_BY_SERVICE.map(r => {
                const diff = Math.round(((r.actualH - r.estimateH) / r.estimateH) * 100);
                const c = diff >= 10 ? '#B91C1C' : diff <= -5 ? '#1D4ED8' : '#166534';
                return (
                  <tr key={r.service} style={{ borderTop: '1px solid #F0EFEB' }}>
                    <td style={{ padding: '10px' }}><b>{r.label}</b></td>
                    <td style={{ padding: '10px' }}>{r.estimateH} h</td>
                    <td style={{ padding: '10px' }}>{Math.floor(r.actualH)} h {Math.round((r.actualH % 1) * 60)} min</td>
                    <td style={{ padding: '10px' }}>
                      <div className="row"><div style={{ position: 'relative', width: 120, height: 8, background: '#F0EFEB', borderRadius: 99 }}>
                        <span style={{ position: 'absolute', left: '50%', top: -3, bottom: -3, width: 2, background: '#8A8B8E' }} />
                        <span style={{ position: 'absolute', top: 0, bottom: 0, [diff > 0 ? 'left' : 'right']: '50%', width: `${Math.min(50, Math.abs(diff) * 2.5)}%`, background: c, borderRadius: 99 }} />
                      </div><b style={{ color: c }}>{diff > 0 ? '+' : ''}{diff}%</b></div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div style={{ background: '#FFF8EA', borderRadius: 10, padding: 10, fontSize: 13 }}>Las profundas tardan 17% más de lo estimado: conviene subir el estimado a <b>3.5 h</b> (o el precio).</div>
      </section>
    </>
  );
}
